module.exports = "/_next/static/images/search--white-a99a02150e7effb872a1b9aabd644c4a.svg";